import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const DirectorsOfficersFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1. Can Directors & Officers Insurance be customized for specific needs?",
      answer: (
        <>
          Yes, insurance providers offer flexibility in customizing Directors & Officers Insurance policies to meet specific needs:
          <ul>
            <li><span style={{ color: "#F37435", fontWeight: "700"}}>Coverage amounts:</span><span style={{ color: "black"}}>Choose limits that match your risk.</span></li>
            <li> <span style={{ color: "#F37435", fontWeight: "700"}}>Deductibles:</span> <span style={{ color: "black"}}>Pay more upfront for lower premiums.</span></li>
            <li><span style={{ color: "#F37435", fontWeight: "700"}}>Add-ons:</span> <span style={{ color: "black"}}>Get extra protection for specific needs (like data breaches).</span></li>
            <li> <span style={{ color: "#F37435", fontWeight: "700"}}>Industry focus:</span> <span style={{ color: "black"}}>Some policies target specific industries (e.g., tech).</span></li>
          </ul>
        </>
      )
    },
   
    {
      question: "Q2. Does Directors & Officers (D&O) insurance cover legal costs if a director gets sued by another director in a personal dispute?",
      answer:(
        <>
        <span style={{ color: "#F37435", fontWeight: "700"}}>Generally, no.</span> D&O insurance typically excludes coverage for disputes between directors that are considered personal in nature.  This insurance focuses on protecting directors and officers from lawsuits arising from their actions related to their official duties for the company.
      </>
      )
      },

      {
        question: "Q3. What are some typical situations where D&O insurance might come into play?",
        answer:(
          <>
          <span style={{ color: "#F37435", fontWeight: "700"}}>Common claims covered by D&O insurance include: </span>1.Breach of fiduciary duty  2.Mismanagement decisions 3.Securities fraud 4.Employment-related lawsuits

        </>
        )
        },
    {
      question: "Q4. Does a small business need d&o insurance?",
      answer: (
        <>
       <span style={{ color: "#F37435", fontWeight: "700"}}>Yes, </span>Small businesses can benefit greatly from D&O insurance! It acts as a protective shield for directors and officers, providing peace of mind and financial security in a world where lawsuits are ever-present.

        </>
      )
      
    
    },
    {
      question: "Q5. How does Directors & Officers Insurance differ from general liability coverage?",
      answer: (
        <>
          <span style={{ color: "#F37435", fontWeight: "700"}}>General Liability (GL) Insurance:</span>
          <ol>
            <li>Focus: <span style={{ color: "black"}}>Protects the business itself from third-party claims of bodily injury, property damage, and certain intangible harms (e.g., advertising injury).</span></li>
            <li>Example:<span style={{ color: "black"}}> A customer slips and falls in your store, or a product you sell malfunctions and damages someone's property. GL insurance would cover the legal costs and potential settlements.</span></li>
            <li> Protects: <span style={{ color: "black"}}>The overall financial stability of the business by covering operational risks.</span></li>
          </ol>
        </>
      )
      
    },
    {
      question: "Q6. Can Directors & Officers Insurance protect personal assets?",
      answer: (
      
       <>
       D&O insurance shields directors' personal assets from lawsuits related to company decisions. It covers legal costs and settlements, but excludes intentional wrongdoing and personal disputes.  Review the policy to understand coverage details. 
        </>

      )
      
    },
   
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default DirectorsOfficersFAQ;